import { css } from '@emotion/react';

export const containerStyle = css`
  cursor: pointer;

  h2 {
    max-width: 200px;
  }
`;
